import React from 'react';
import {
  Hero2Section,
  ContainerStyled,
  Element1Styled,
  Element2Styled,
} from './hero2.style';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HeadLineComponent from 'common/HeadLine';
import DescriptionComponent from 'common/Description';
import NextImage from 'common/components/NextImage';
import {
  ButtonLogoWrapper,
  PrimaryButton,
  SecondaryButton,
} from 'containers/SaasModern/Banner/banner.style';
import Container from 'common/components/Container';


const Hero2 = ({ slice }) => {  
  return (
    <Hero2Section>
      <Container>
        <ContainerStyled>
          <Element1Styled>
            <div data-aos="zoom-in">
              <HeadLineComponent field={slice.primary.title} />
            </div>
            <div data-aos="zoom-in">
              <DescriptionComponent field={slice.primary.description} />
            </div>
            <ButtonLogoWrapper data-aos="zoom-in">
              {slice.primary.cta_try_swiftask &&
                slice.primary.cta_try_swiftask.trim() !== '' && (
                  <PrimaryButton
                    onClick={() => {
                      const url = slice.primary.linktryswiftask;
                      window.open(url, '_blank');
                    }}
                  >
                    {slice.primary.cta_try_swiftask}
                    <ArrowForwardIcon sx={{ marginLeft: '8px' }} />
                  </PrimaryButton>
                )}
              {slice.primary.cta_book_demo &&
                slice.primary.cta_book_demo.trim() !== '' && (
                  <SecondaryButton
                    onClick={() => {
                      window.open('/contact-us', '_blank');
                    }}
                  >
                    {slice.primary.cta_book_demo}
                  </SecondaryButton>
                )}
            </ButtonLogoWrapper>
          </Element1Styled>
          <Element2Styled data-aos="zoom-in">
            <NextImage
              field={slice.primary.image}
              priority={true}
            />
          </Element2Styled>
        </ContainerStyled>
      </Container>
    </Hero2Section>
  );
};

export default Hero2;
